
import { showLoading, hideLoading } from '@/libs/components/Loading'


export default {
  show: showLoading,
  hide: hideLoading
}